import React from 'react'

function EstadisticaMensual() {
  return (
    <div>
        <h1>Agosto: </h1>
        promedio: 731677
        <h2>Realizo: 22682000</h2>
        <h2>Gatos: 20972100</h2>
        <br />
        <h1>Septiembre:</h1>
        promedio: 743566
        <h2>Realizo:22307000</h2>
        <h2>Gastos:21507000</h2>
        <br/>
        <h1>Octubre:</h1>
        promedio: 705516
        <h2>Realizo:21871000</h2>
        <h2>Gastos:22311400</h2>

        <br />
        <h1>Noviembre:</h1>
        promedio: 708333
        <h2>Realizo:21250000</h2>
        <h2>Gastos:20987050</h2>

        <br />
        <h1>diciembre:</h1>
        promedio: 776225
        <h2>Realizo:24063000</h2>
        <h2>Gastos:24323250</h2>
        <br />
        <h1>enero:</h1>
        promedio: 781796
        <h2>Realizo:24235700</h2>
        <h2>Gastos:21604250</h2>

        <br />
        <h1>febrero:</h1>
        promedio: 861965 
        <h2>Realizo:24997000</h2>
        <h2>Gastos:23426100</h2>

        <br />
        <h1>marzo:</h1>
        promedio:912700
        <h2>Realizo: 28294000</h2>
        <h2>Gastos: 28130450</h2>
        acumulado anterior realizo 189644000
        gastos 183261600
        <br />
        <h1>abril:</h1>
        promedio: 979000
        <h2>Realizo: 29371000</h2>
        <h2>Gastos: 28828250</h2>
        acumulado anterior realizo 219015000
        gastos 212089850
        <br />
        <h1>mayo:</h1>
        promedio: 931000
        <h2>Realizo: 28866000</h2>
        <h2>Gastos: 31253850</h2>
        acumulado anterior realizo 247881000
        gastos 243253850
        <br />
        <h1>junio:</h1>
        promedio: 938000
        <h2>Realizo:28155000</h2>
        <h2>Gastos:26985150</h2>
        acumulado anterior realizo 276036000
        gastos 270239000
        <br />
        <h1>julio:</h1>
        promedio: 957000
        <h2>Realizo:29678000</h2>
        <h2>Gastos:25553650</h2>
        acumulado anterior realizo 305714000
        gastos 295792650
        <br />
        <h1>Agosto:</h1>
        promedio: 911000
        <h2>Realizo: 28240400</h2>
        <h2>Gastos:28209900</h2>
        acumulado anterior realizo 333954400
        gastos 324002550
        <br />
        <h1>Septiembre:</h1>
        promedio: 1237500
        <h2>Realizo: 37126000</h2>
        <h2>Gastos:35812250</h2>
        acumulado anterior realizo 371080400
        gastos 359814800

        <br />
        <h1>octubre:</h1>
        promedio: 1216600
        <h2>Realizo: 37708000</h2>
        <h2>Gastos:31060750</h2>
        acumulado anterior realizo 408788400
        gastos 390875550
        
        <br />
        <h1>noviembre:</h1>
        promedio: 1116000
        <h2>Realizo: 33486000</h2>
        <h2>Gastos:37652100</h2>
        acumulado anterior realizo 442274400
        gastos 428527650
    </div>
  )
}

export default EstadisticaMensual